const modalInitialState = {
  className: '',
  left:      '',
  open:      false,
  title:     '',
  top:       '',
  body:      '',
  large:     false,
};

export default modalInitialState;